import React from "react";
import style from './reports.module.scss';

function ReportsPage() {
  return (
  	<div className={style.Reports}>
  		🚀 ReportsPage created 
	</div>
  )
}

export default ReportsPage;
